import { useDispatch } from 'react-redux'
import { RedeemActions } from 'features'
import { useEffect } from 'react'
import { RedeemStepsE } from 'types'

const StartAllowance = (): JSX.Element | null => {
  const dispatch = useDispatch()

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(RedeemActions.setCurrentStep(RedeemStepsE.CHECK_ALLOWANCE))
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [dispatch])

  return null
}

export { StartAllowance }
